import React, { useState } from "react";
import "../css/ForgotPassword.css";
import dogCatImage from "../assets/view-cats-dogs-showing-friendship 1.png";
import { Link, useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSendOTP = (e) => {
    e.preventDefault();

    if (!inputValue.trim()) {
      setError("Please enter email or phone number.");
    } else if (isNaN(inputValue)) {
      // Email validation
      if (!inputValue.includes("@")) {
        setError("Please enter a valid email address.");
      } else if (inputValue !== "admin@gmail.com") {
        setError("Email not recognized.");
      } else {
        setError("");
        navigate("/otp");
      }
    } else {
      // Phone validation
      if (inputValue !== "1234567890") {
        setError("Please enter a valid phone number.");
      } else {
        setError("");
        navigate("/otp");
      }
    }
  };

  return (
    <div className="fp-container">
      <div className="fp-left">
        <h2 className="fp-left-header">
          Reset Your Password – Reconnect With Your Pet’s World!
        </h2>
        <img src={dogCatImage} className="fp-image" alt="Dog and Cat" />
      </div>
      <div className="fp-right">
        <h2 className="fp-right-header">Forgot Password</h2>
        <form className="fp-form" onSubmit={handleSendOTP}>
          <label className="fp-form-label">Email or Phone Number</label>
          <div className="fp-btn-separator">
            <input
              className="fp-form-input"
              type="text"
              placeholder="designer@gmail.com"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
            {error && <p className="fp-error">{error}</p>}
            <button type="submit" className="fp-otp-button">
              Send OTP
            </button>
          </div>
        </form>

        <p className="fp-signup-text">
          Did you remember your password?
          <span>
            {" "}
            <Link to="/">Login</Link>
          </span>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;